import { StyleSheet, Platform, Dimensions } from 'react-native'

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  mainTitleStyle: theme => ({
    color: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? theme.colors.textColorTwo : theme.colors.textColorThree,
    fontFamily: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? Fonts.type.VFFont : Fonts.type.VodafoneLt,
    fontSize: 26,
    fontStyle: 'normal',
    fontWeight: 'normal',
    letterSpacing: 0,
    lineHeight: 31.2,
    flexShrink: 1,
    marginBottom: 10,
    marginLeft: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 12
  }),
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    // justifyContent: 'space-between',
    marginTop: Platform.OS === 'ios' ? 17.7 : 16.9,
  },
  headerIcon: {
    // position: 'absolute',
    // top: 1,
  },
  contentPadding: {
    marginHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : 16
  },
  secureText: theme => ({
    width: '100%',
    marginLeft: 0,
    fontSize: 15,
    color: theme.colors.textColor,
  }),
  inputContainer: {
    marginHorizontal: 0,
  },
  halfSizeContainer: {
    marginHorizontal: 0,
    width: '48%',
  },
  topUpSomeOneContainer: {
    minHeight: Platform.OS === 'ios' ? 400 : 380,
    marginHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : -16,
  },
  description: theme => ({
    fontSize: 17,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 23,
    letterSpacing: 0,
    color: theme.colors.textColorThree,
    width: '100%',
    paddingHorizontal: 1,
  }),
  setupAutobillContainer: {
    marginHorizontal: -16,
  },
  setupAutoTopUpContainer: {
    marginHorizontal: -16,
  },
  title: theme => ({
    fontSize: 24,
    paddingTop: 18,
    color: theme.colors.text.primary,
    lineHeight: 30,
    fontFamily: Fonts.type.VodafoneLt,
  }),
});
